import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Import de tous les fichiers CSS (déconseillé)
import './styles/app.css';
import './styles/base.css';
import './styles/calendar.css';
import './styles/cards.css';
import './styles/carousel.css';
import './styles/charts.css';
import './styles/fiche-salarie.css';
import './styles/forms.css';
import './styles/hero.css';
import './styles/lists.css';
import './styles/navbar.css';
import './styles/services.css';
import './styles/utils.css';
import './styles/variables.css';
import './styles/settings.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
